import { ChevronRightIcon } from "@chakra-ui/icons";
import { Box, BoxProps, Button, ButtonProps } from "@chakra-ui/react";
import { ReactNode } from "react";

type CollapseToggleIconProps = BoxProps & {
  collapsedOffsetDegrees?: number;
  expandedOffsetDegrees?: number;
};

type CollapseToggleIconFrameProps = CollapseToggleIconProps & {
  children: ReactNode;
};

function CollapseToggleIconFrame({
  children,
  collapsedOffsetDegrees,
  expandedOffsetDegrees = collapsedOffsetDegrees,
  ...rest
}: CollapseToggleIconFrameProps) {
  return (
    <Box
      as="span"
      display="inline-block"
      transition="transform 200ms"
      transform={
        collapsedOffsetDegrees
          ? `rotate(${collapsedOffsetDegrees}deg)`
          : undefined
      }
      sx={{
        "[aria-expanded=true] > &, [aria-expanded=true] > .chakra-button__icon > & ":
          {
            transform: `rotate(${-((expandedOffsetDegrees || 0) + 90)}deg)`,
          },
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}

export function CollapseToggleIcon(props: CollapseToggleIconProps) {
  return (
    <CollapseToggleIconFrame lineHeight={2} {...props}>
      &#9664;&#xfe0e;
    </CollapseToggleIconFrame>
  );
}

export function CollapseToggleChevronIcon({
  collapsedOffsetDegrees = 180,
  expandedOffsetDegrees = -180,
  ...rest
}: CollapseToggleIconProps) {
  return (
    <CollapseToggleIconFrame
      lineHeight={0}
      collapsedOffsetDegrees={collapsedOffsetDegrees}
      expandedOffsetDegrees={expandedOffsetDegrees}
      {...rest}
    >
      <ChevronRightIcon boxSize="1.25em" />
    </CollapseToggleIconFrame>
  );
}

type Props = ButtonProps & {
  controlsId?: string;
  isExpanded?: boolean;
  onExpandedChange?: (isExpanded: boolean) => void;
};

export default function CollapseToggleButton({
  children = <CollapseToggleIcon />,
  controlsId,
  isExpanded,
  onClick,
  onExpandedChange,
  ...rest
}: Props) {
  return (
    <Button
      {...rest}
      onClick={(evt) => {
        onClick?.(evt);
        onExpandedChange?.(!isExpanded);
      }}
      aria-controls={controlsId}
      aria-expanded={isExpanded}
    >
      {children}
    </Button>
  );
}
